export default "__VITE_ASSET__ClLoYSdE__"